import { Card, CardContent, Grid, Box } from '@mui/material';
import { IUserDTO } from 'wisestep-api';
import { WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { userDetails } from './helper/profileHelper';
import UserProfileInfoRender from './UserProfileInfoRender';

type UserDetailsProps = {
  user: IUserDTO | null;

  smsNumber?: string;
  jobBoardAccount?: string;
  emailsConfigured?: string | number;
  jobPublishingAccounts?: string | number;
  calendarAccounts?: string | number;
  clientsAllocated?: string | number;
  address?: string;
  about?: string;
};

const UserProfileDetails = ({ user, address, about }: UserDetailsProps) => {
  const data = userDetails(user, address, about);
  return (
    <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
      <Box
        sx={{
          backgroundColor: WsColors.White,
          px: 2,
          py: 1,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }}
      >
        <WsTypography variant={WsTypoVariants.TITLE}>User Details</WsTypography>
      </Box>
      <CardContent>
        <Grid container spacing={3}>
          <UserProfileInfoRender fields={data} />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UserProfileDetails;
